import React from 'react';

export default function LoadingScreen({ text = 'Chargement des questions…' }) {
  return (
    <div className="page-content" style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'60vh', gap:'1rem' }}>
      <div style={{ fontSize:'2.5rem' }}>📖</div>
      <p className="text-small">{text}</p>
      <div style={{ width:48, height:4, borderRadius:99, background:'rgba(201,168,76,.15)', overflow:'hidden' }}>
        <div style={{ height:'100%', background:'var(--gold)', borderRadius:99, animation:'loading-bar 1.5s ease-in-out infinite' }} />
      </div>
    </div>
  );
}
